import { API } from 'aws-amplify';

const createUser = async data => {
  const newUser = await API.post('agentbuzz', 'users', {
    body: createUserData(data),
  });
  return newUser;
};

const createUserData = data => {
  const name = data.name.split(' ');
  const address = {
    line1: data.card.address_line1,
    line2: data.card.address_line2 || null,
    city: data.card.address_city,
    state: data.card.address_state,
    zip: data.card.address_zip,
  };
  const userData = {
    userType: data.userType,
    userName: data.userName,
    firstName: name[0],
    lastName: name[1],
    email: data.email,
    phoneNumber: data.phoneNumber,
    billingAddress: address,
    shippingAddress: address,
    s_customerId: data.customerId,
    planId: `plan_${data.plan.id}`,
    localPhoneNumber: data.localPhoneNumber || null,
    teamId: data.teamId || null,
  };

  return userData;
};

export default createUser;



// WEBPACK FOOTER //
// ./src/services/user/createUser.js